// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Formality from "../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Belt_Result from "../../../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as TicketStatus from "../../../../to-be-migrated/domain/types/order/tickets/TicketStatus.bs.js";
import * as GeoRegionHook from "../../../../../../library/data-source/geo-region/repo/GeoRegionHook.bs.js";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as TicketRaisedBy from "../../../app/tickets/entities/TicketRaisedBy.bs.js";
import * as Button$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/Button.bs.js";
import * as MsisdnValidation from "../../../../../../library/work-space/form/MsisdnValidation.bs.js";
import * as WorkSpaceContext from "../../../../../../library/work-space/WorkSpaceContext.bs.js";
import * as Accordion$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/Accordion.bs.js";
import * as FormInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as GeoRegionRepoManager from "../../../../../../library/data-source/geo-region/repo/GeoRegionRepoManager.bs.js";
import * as TicketsRequestMapper from "../../../app/tickets/entitiy-mapper/TicketsRequestMapper.bs.js";
import * as FormTextInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";
import * as Formality__ReactUpdate from "../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as MobileNumberValidation from "../../../../../../library/work-space/form/MobileNumberValidation.bs.js";
import * as AccordionTypes$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/AccordionTypes.bs.js";
import * as FormSelectInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormSelectInput.bs.js";
import * as PrimitiveFormTypes$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/PrimitiveFormTypes.bs.js";
import * as FormDateTimeInputTs$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/date-time/FormDateTimeInputTs.bs.js";
import * as FormValidationUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/FormValidationUtils.bs.js";
import * as FetchLoadableViewMapper$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/FetchLoadableViewMapper.bs.js";

function validateCaseNumber(case_number) {
  if (/^[0-9]{8}$/.test(case_number)) {
    return {
            TAG: /* Ok */0,
            _0: case_number
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: "Invalid Case number"
          };
  }
}

var FormHelper = {
  validateCaseNumber: validateCaseNumber
};

var validators_raised_by = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      var raised_by = param.raised_by;
      if (raised_by !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: TicketRaisedBy.fromString(raised_by.value)
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_geo_region = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      var geo_region = param.geo_region;
      if (geo_region !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: geo_region.value
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_ticket_status = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      var ticket_status = param.ticket_status;
      if (ticket_status !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: TicketStatus.fromString(ticket_status.value)
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_msisdn = {
  strategy: /* OnSubmit */4,
  validate: (function (param, metadata) {
      return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                      TAG: /* Opt */0,
                      _0: {
                        TAG: /* String */1,
                        _0: param.msisdn
                      }
                    }), (function (msisdn) {
                    if (msisdn === undefined) {
                      return {
                              TAG: /* Ok */0,
                              _0: undefined
                            };
                    }
                    var error = MsisdnValidation.execute(msisdn, metadata.country);
                    if (error.TAG === /* Ok */0) {
                      return {
                              TAG: /* Ok */0,
                              _0: error._0
                            };
                    } else {
                      return {
                              TAG: /* Error */1,
                              _0: error._0
                            };
                    }
                  }));
    })
};

var validators_caller_number = {
  strategy: /* OnSubmit */4,
  validate: (function (param, metadata) {
      return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                      TAG: /* Opt */0,
                      _0: {
                        TAG: /* String */1,
                        _0: param.caller_number
                      }
                    }), (function (caller_number) {
                    if (caller_number === undefined) {
                      return {
                              TAG: /* Ok */0,
                              _0: undefined
                            };
                    }
                    var error = MobileNumberValidation.execute(caller_number, metadata.country);
                    if (error.TAG === /* Ok */0) {
                      return {
                              TAG: /* Ok */0,
                              _0: error._0
                            };
                    } else {
                      return {
                              TAG: /* Error */1,
                              _0: error._0
                            };
                    }
                  }));
    })
};

var validators_case_number = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                      TAG: /* Opt */0,
                      _0: {
                        TAG: /* String */1,
                        _0: param.case_number
                      }
                    }), (function (case_number) {
                    if (case_number === undefined) {
                      return {
                              TAG: /* Ok */0,
                              _0: undefined
                            };
                    }
                    var error = validateCaseNumber(case_number);
                    if (error.TAG === /* Ok */0) {
                      return {
                              TAG: /* Ok */0,
                              _0: error._0
                            };
                    } else {
                      return {
                              TAG: /* Error */1,
                              _0: error._0
                            };
                    }
                  }));
    })
};

var validators_crn = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                      TAG: /* Opt */0,
                      _0: {
                        TAG: /* String */1,
                        _0: param.crn
                      }
                    }), (function (crn) {
                    if (crn === undefined) {
                      return {
                              TAG: /* Ok */0,
                              _0: undefined
                            };
                    }
                    var error = FormValidationUtils$Catalyst.validateCRN(crn);
                    if (error.TAG === /* Ok */0) {
                      return {
                              TAG: /* Ok */0,
                              _0: error._0
                            };
                    } else {
                      return {
                              TAG: /* Error */1,
                              _0: error._0
                            };
                    }
                  }));
    })
};

var validators = {
  raised_by: validators_raised_by,
  geo_region: validators_geo_region,
  ticket_status: validators_ticket_status,
  end_datetime: undefined,
  start_datetime: undefined,
  msisdn: validators_msisdn,
  caller_number: validators_caller_number,
  case_number: validators_case_number,
  crn: validators_crn
};

function initialFieldsStatuses(_input) {
  return {
          raised_by: /* Pristine */0,
          geo_region: /* Pristine */0,
          ticket_status: /* Pristine */0,
          end_datetime: /* Pristine */0,
          start_datetime: /* Pristine */0,
          msisdn: /* Pristine */0,
          caller_number: /* Pristine */0,
          case_number: /* Pristine */0,
          crn: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: initialFieldsStatuses(input),
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses, metadata) {
  var match = fieldsStatuses.raised_by;
  var match_0 = match ? match._0 : Curry._2(validators.raised_by.validate, input, metadata);
  var match$1 = fieldsStatuses.geo_region;
  var match_0$1 = match$1 ? match$1._0 : Curry._2(validators.geo_region.validate, input, metadata);
  var match$2 = fieldsStatuses.ticket_status;
  var match_0$2 = match$2 ? match$2._0 : Curry._2(validators.ticket_status.validate, input, metadata);
  var match_0$3 = {
    TAG: /* Ok */0,
    _0: input.end_datetime
  };
  var match_0$4 = {
    TAG: /* Ok */0,
    _0: input.start_datetime
  };
  var match$3 = fieldsStatuses.msisdn;
  var match_0$5 = match$3 ? match$3._0 : Curry._2(validators.msisdn.validate, input, metadata);
  var match$4 = fieldsStatuses.caller_number;
  var match_0$6 = match$4 ? match$4._0 : Curry._2(validators.caller_number.validate, input, metadata);
  var match$5 = fieldsStatuses.case_number;
  var match_0$7 = match$5 ? match$5._0 : Curry._2(validators.case_number.validate, input, metadata);
  var match$6 = fieldsStatuses.crn;
  var match_0$8 = match$6 ? match$6._0 : Curry._2(validators.crn.validate, input, metadata);
  var raised_byResult = match_0;
  var raised_byResult$1;
  if (raised_byResult.TAG === /* Ok */0) {
    var geo_regionResult = match_0$1;
    if (geo_regionResult.TAG === /* Ok */0) {
      var ticket_statusResult = match_0$2;
      if (ticket_statusResult.TAG === /* Ok */0) {
        var end_datetimeResult = match_0$3;
        if (end_datetimeResult.TAG === /* Ok */0) {
          var start_datetimeResult = match_0$4;
          if (start_datetimeResult.TAG === /* Ok */0) {
            var msisdnResult = match_0$5;
            if (msisdnResult.TAG === /* Ok */0) {
              var caller_numberResult = match_0$6;
              if (caller_numberResult.TAG === /* Ok */0) {
                var case_numberResult = match_0$7;
                if (case_numberResult.TAG === /* Ok */0) {
                  var crnResult = match_0$8;
                  if (crnResult.TAG === /* Ok */0) {
                    return {
                            TAG: /* Valid */0,
                            output: {
                              crn: crnResult._0,
                              case_number: case_numberResult._0,
                              caller_number: caller_numberResult._0,
                              msisdn: msisdnResult._0,
                              start_datetime: start_datetimeResult._0,
                              end_datetime: end_datetimeResult._0,
                              ticket_status: ticket_statusResult._0,
                              geo_region: geo_regionResult._0,
                              raised_by: raised_byResult._0
                            },
                            fieldsStatuses: {
                              raised_by: /* Dirty */{
                                _0: raised_byResult,
                                _1: /* Shown */0
                              },
                              geo_region: /* Dirty */{
                                _0: geo_regionResult,
                                _1: /* Shown */0
                              },
                              ticket_status: /* Dirty */{
                                _0: ticket_statusResult,
                                _1: /* Shown */0
                              },
                              end_datetime: /* Dirty */{
                                _0: end_datetimeResult,
                                _1: /* Hidden */1
                              },
                              start_datetime: /* Dirty */{
                                _0: start_datetimeResult,
                                _1: /* Hidden */1
                              },
                              msisdn: /* Dirty */{
                                _0: msisdnResult,
                                _1: /* Shown */0
                              },
                              caller_number: /* Dirty */{
                                _0: caller_numberResult,
                                _1: /* Shown */0
                              },
                              case_number: /* Dirty */{
                                _0: case_numberResult,
                                _1: /* Shown */0
                              },
                              crn: /* Dirty */{
                                _0: crnResult,
                                _1: /* Shown */0
                              }
                            },
                            collectionsStatuses: undefined
                          };
                  }
                  raised_byResult$1 = raised_byResult;
                } else {
                  raised_byResult$1 = raised_byResult;
                }
              } else {
                raised_byResult$1 = raised_byResult;
              }
            } else {
              raised_byResult$1 = raised_byResult;
            }
          } else {
            raised_byResult$1 = raised_byResult;
          }
        } else {
          raised_byResult$1 = raised_byResult;
        }
      } else {
        raised_byResult$1 = raised_byResult;
      }
    } else {
      raised_byResult$1 = raised_byResult;
    }
  } else {
    raised_byResult$1 = raised_byResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            raised_by: /* Dirty */{
              _0: raised_byResult$1,
              _1: /* Shown */0
            },
            geo_region: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            },
            ticket_status: /* Dirty */{
              _0: match_0$2,
              _1: /* Shown */0
            },
            end_datetime: /* Dirty */{
              _0: match_0$3,
              _1: /* Hidden */1
            },
            start_datetime: /* Dirty */{
              _0: match_0$4,
              _1: /* Hidden */1
            },
            msisdn: /* Dirty */{
              _0: match_0$5,
              _1: /* Shown */0
            },
            caller_number: /* Dirty */{
              _0: match_0$6,
              _1: /* Shown */0
            },
            case_number: /* Dirty */{
              _0: match_0$7,
              _1: /* Shown */0
            },
            crn: /* Dirty */{
              _0: match_0$8,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, metadata, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurRaised_byField */0 :
                  var result = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.raised_by, validators_raised_by, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  raised_by: status,
                                  geo_region: init.geo_region,
                                  ticket_status: init.ticket_status,
                                  end_datetime: init.end_datetime,
                                  start_datetime: init.start_datetime,
                                  msisdn: init.msisdn,
                                  caller_number: init.caller_number,
                                  case_number: init.case_number,
                                  crn: init.crn
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurGeo_regionField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.geo_region, validators_geo_region, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  raised_by: init.raised_by,
                                  geo_region: status,
                                  ticket_status: init.ticket_status,
                                  end_datetime: init.end_datetime,
                                  start_datetime: init.start_datetime,
                                  msisdn: init.msisdn,
                                  caller_number: init.caller_number,
                                  case_number: init.case_number,
                                  crn: init.crn
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurTicket_statusField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.ticket_status, validators_ticket_status, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  raised_by: init.raised_by,
                                  geo_region: init.geo_region,
                                  ticket_status: status,
                                  end_datetime: init.end_datetime,
                                  start_datetime: init.start_datetime,
                                  msisdn: init.msisdn,
                                  caller_number: init.caller_number,
                                  case_number: init.case_number,
                                  crn: init.crn
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurEnd_datetimeField */3 :
                  var result$3 = Formality.validateFieldOnBlurWithoutValidator(state.input.end_datetime, state.fieldsStatuses.end_datetime, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  raised_by: init.raised_by,
                                  geo_region: init.geo_region,
                                  ticket_status: init.ticket_status,
                                  end_datetime: status,
                                  start_datetime: init.start_datetime,
                                  msisdn: init.msisdn,
                                  caller_number: init.caller_number,
                                  case_number: init.case_number,
                                  crn: init.crn
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurStart_datetimeField */4 :
                  var result$4 = Formality.validateFieldOnBlurWithoutValidator(state.input.start_datetime, state.fieldsStatuses.start_datetime, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  raised_by: init.raised_by,
                                  geo_region: init.geo_region,
                                  ticket_status: init.ticket_status,
                                  end_datetime: init.end_datetime,
                                  start_datetime: status,
                                  msisdn: init.msisdn,
                                  caller_number: init.caller_number,
                                  case_number: init.case_number,
                                  crn: init.crn
                                };
                        }));
                  if (result$4 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$4,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurMsisdnField */5 :
                  var result$5 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.msisdn, validators_msisdn, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  raised_by: init.raised_by,
                                  geo_region: init.geo_region,
                                  ticket_status: init.ticket_status,
                                  end_datetime: init.end_datetime,
                                  start_datetime: init.start_datetime,
                                  msisdn: status,
                                  caller_number: init.caller_number,
                                  case_number: init.case_number,
                                  crn: init.crn
                                };
                        }));
                  if (result$5 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$5,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurCaller_numberField */6 :
                  var result$6 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.caller_number, validators_caller_number, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  raised_by: init.raised_by,
                                  geo_region: init.geo_region,
                                  ticket_status: init.ticket_status,
                                  end_datetime: init.end_datetime,
                                  start_datetime: init.start_datetime,
                                  msisdn: init.msisdn,
                                  caller_number: status,
                                  case_number: init.case_number,
                                  crn: init.crn
                                };
                        }));
                  if (result$6 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$6,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurCase_numberField */7 :
                  var result$7 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.case_number, validators_case_number, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  raised_by: init.raised_by,
                                  geo_region: init.geo_region,
                                  ticket_status: init.ticket_status,
                                  end_datetime: init.end_datetime,
                                  start_datetime: init.start_datetime,
                                  msisdn: init.msisdn,
                                  caller_number: init.caller_number,
                                  case_number: status,
                                  crn: init.crn
                                };
                        }));
                  if (result$7 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$7,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurCrnField */8 :
                  var result$8 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.crn, validators_crn, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  raised_by: init.raised_by,
                                  geo_region: init.geo_region,
                                  ticket_status: init.ticket_status,
                                  end_datetime: init.end_datetime,
                                  start_datetime: init.start_datetime,
                                  msisdn: init.msisdn,
                                  caller_number: init.caller_number,
                                  case_number: init.case_number,
                                  crn: status
                                };
                        }));
                  if (result$8 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$8,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */9 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses, metadata);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */9,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */10,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */12);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */11);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */10 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */11 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */12 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateRaised_byField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput, metadata, state.fieldsStatuses.raised_by, state.submissionStatus, validators_raised_by, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            raised_by: status,
                                            geo_region: init.geo_region,
                                            ticket_status: init.ticket_status,
                                            end_datetime: init.end_datetime,
                                            start_datetime: init.start_datetime,
                                            msisdn: init.msisdn,
                                            caller_number: init.caller_number,
                                            case_number: init.case_number,
                                            crn: init.crn
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateGeo_regionField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$1, metadata, state.fieldsStatuses.geo_region, state.submissionStatus, validators_geo_region, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            raised_by: init.raised_by,
                                            geo_region: status,
                                            ticket_status: init.ticket_status,
                                            end_datetime: init.end_datetime,
                                            start_datetime: init.start_datetime,
                                            msisdn: init.msisdn,
                                            caller_number: init.caller_number,
                                            case_number: init.case_number,
                                            crn: init.crn
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateTicket_statusField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$2, metadata, state.fieldsStatuses.ticket_status, state.submissionStatus, validators_ticket_status, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            raised_by: init.raised_by,
                                            geo_region: init.geo_region,
                                            ticket_status: status,
                                            end_datetime: init.end_datetime,
                                            start_datetime: init.start_datetime,
                                            msisdn: init.msisdn,
                                            caller_number: init.caller_number,
                                            case_number: init.case_number,
                                            crn: init.crn
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateEnd_datetimeField */3 :
                  var nextInput$3 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$3.end_datetime, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            raised_by: init.raised_by,
                                            geo_region: init.geo_region,
                                            ticket_status: init.ticket_status,
                                            end_datetime: status,
                                            start_datetime: init.start_datetime,
                                            msisdn: init.msisdn,
                                            caller_number: init.caller_number,
                                            case_number: init.case_number,
                                            crn: init.crn
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateStart_datetimeField */4 :
                  var nextInput$4 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$4,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$4.start_datetime, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            raised_by: init.raised_by,
                                            geo_region: init.geo_region,
                                            ticket_status: init.ticket_status,
                                            end_datetime: init.end_datetime,
                                            start_datetime: status,
                                            msisdn: init.msisdn,
                                            caller_number: init.caller_number,
                                            case_number: init.case_number,
                                            crn: init.crn
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateMsisdnField */5 :
                  var nextInput$5 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$5,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$5, metadata, state.fieldsStatuses.msisdn, state.submissionStatus, validators_msisdn, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            raised_by: init.raised_by,
                                            geo_region: init.geo_region,
                                            ticket_status: init.ticket_status,
                                            end_datetime: init.end_datetime,
                                            start_datetime: init.start_datetime,
                                            msisdn: status,
                                            caller_number: init.caller_number,
                                            case_number: init.case_number,
                                            crn: init.crn
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateCaller_numberField */6 :
                  var nextInput$6 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$6,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$6, metadata, state.fieldsStatuses.caller_number, state.submissionStatus, validators_caller_number, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            raised_by: init.raised_by,
                                            geo_region: init.geo_region,
                                            ticket_status: init.ticket_status,
                                            end_datetime: init.end_datetime,
                                            start_datetime: init.start_datetime,
                                            msisdn: init.msisdn,
                                            caller_number: status,
                                            case_number: init.case_number,
                                            crn: init.crn
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateCase_numberField */7 :
                  var nextInput$7 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$7,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$7, metadata, state.fieldsStatuses.case_number, state.submissionStatus, validators_case_number, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            raised_by: init.raised_by,
                                            geo_region: init.geo_region,
                                            ticket_status: init.ticket_status,
                                            end_datetime: init.end_datetime,
                                            start_datetime: init.start_datetime,
                                            msisdn: init.msisdn,
                                            caller_number: init.caller_number,
                                            case_number: status,
                                            crn: init.crn
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateCrnField */8 :
                  var nextInput$8 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$8,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$8, metadata, state.fieldsStatuses.crn, state.submissionStatus, validators_crn, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            raised_by: init.raised_by,
                                            geo_region: init.geo_region,
                                            ticket_status: init.ticket_status,
                                            end_datetime: init.end_datetime,
                                            start_datetime: init.start_datetime,
                                            msisdn: init.msisdn,
                                            caller_number: init.caller_number,
                                            case_number: init.case_number,
                                            crn: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */9 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: initialFieldsStatuses(input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: initialFieldsStatuses(state.input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */10 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */11 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateRaised_by: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateRaised_byField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateGeo_region: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateGeo_regionField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateTicket_status: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateTicket_statusField */2,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateEnd_datetime: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateEnd_datetimeField */3,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateStart_datetime: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateStart_datetimeField */4,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateMsisdn: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateMsisdnField */5,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateCaller_number: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateCaller_numberField */6,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateCase_number: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateCase_numberField */7,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateCrn: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateCrnField */8,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurRaised_by: (function (param) {
              return Curry._1(dispatch, /* BlurRaised_byField */0);
            }),
          blurGeo_region: (function (param) {
              return Curry._1(dispatch, /* BlurGeo_regionField */1);
            }),
          blurTicket_status: (function (param) {
              return Curry._1(dispatch, /* BlurTicket_statusField */2);
            }),
          blurEnd_datetime: (function (param) {
              return Curry._1(dispatch, /* BlurEnd_datetimeField */3);
            }),
          blurStart_datetime: (function (param) {
              return Curry._1(dispatch, /* BlurStart_datetimeField */4);
            }),
          blurMsisdn: (function (param) {
              return Curry._1(dispatch, /* BlurMsisdnField */5);
            }),
          blurCaller_number: (function (param) {
              return Curry._1(dispatch, /* BlurCaller_numberField */6);
            }),
          blurCase_number: (function (param) {
              return Curry._1(dispatch, /* BlurCase_numberField */7);
            }),
          blurCrn: (function (param) {
              return Curry._1(dispatch, /* BlurCrnField */8);
            }),
          raised_byResult: Formality.exposeFieldResult(state.fieldsStatuses.raised_by),
          geo_regionResult: Formality.exposeFieldResult(state.fieldsStatuses.geo_region),
          ticket_statusResult: Formality.exposeFieldResult(state.fieldsStatuses.ticket_status),
          end_datetimeResult: Formality.exposeFieldResult(state.fieldsStatuses.end_datetime),
          start_datetimeResult: Formality.exposeFieldResult(state.fieldsStatuses.start_datetime),
          msisdnResult: Formality.exposeFieldResult(state.fieldsStatuses.msisdn),
          caller_numberResult: Formality.exposeFieldResult(state.fieldsStatuses.caller_number),
          case_numberResult: Formality.exposeFieldResult(state.fieldsStatuses.case_number),
          crnResult: Formality.exposeFieldResult(state.fieldsStatuses.crn),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.raised_by || match.geo_region || match.ticket_status || match.end_datetime || match.start_datetime || match.msisdn || match.caller_number || match.case_number || match.crn) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses, metadata);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */9);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */10);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */11);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */11,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */12);
            })
        };
}

var Form = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function getInitialState(filter) {
  return {
          crn: Belt_Option.getWithDefault(filter.crn, ""),
          case_number: Belt_Option.getWithDefault(filter.case_number, ""),
          caller_number: Belt_Option.getWithDefault(filter.caller_number, ""),
          msisdn: Belt_Option.getWithDefault(filter.msisdn, ""),
          start_datetime: filter.start_datetime,
          end_datetime: filter.end_datetime,
          ticket_status: FormSelectInput$Catalyst.SelectUtils.getSelectComponentItem(filter.ticket_status, TicketStatus.toString),
          geo_region: FormSelectInput$Catalyst.SelectUtils.getSelectComponentItem(filter.geo_region, (function (a) {
                  return a;
                })),
          raised_by: FormSelectInput$Catalyst.SelectUtils.getSelectComponentItem(filter.raised_by, TicketRaisedBy.toString)
        };
}

function FilterTicketForm$FormComponent(Props) {
  var geoRegions = Props.geoRegions;
  var filter = Props.filter;
  var applyFilter = Props.applyFilter;
  var total_items = Props.total_items;
  var workspaceDispatch = WorkSpaceContext.useWorkSpace(undefined);
  var match = React.useState(function () {
        
      });
  var updateError = match[1];
  var match$1 = CountryContext.useContext(undefined);
  var raisedByOptions = FormSelectInput$Catalyst.SelectUtils.getTypeItems(TicketRaisedBy.getListOfRaisedBy(undefined), TicketRaisedBy.toString);
  var ticketStatusOptions = FormSelectInput$Catalyst.SelectUtils.getTypeItems(TicketStatus.getListOfTicketStatus(undefined), TicketStatus.toString);
  var geoRegionOptions = FormSelectInput$Catalyst.SelectUtils.getTypeItems(geoRegions, (function (x) {
          return x.name;
        }));
  var form = useForm(getInitialState(filter), {
        country: match$1.country
      }, (function (output, _submissionCallbacks) {
          var filterPrarms_crn = output.crn;
          var filterPrarms_case_number = output.case_number;
          var filterPrarms_caller_number = output.caller_number;
          var filterPrarms_msisdn = output.msisdn;
          var filterPrarms_start_datetime = output.start_datetime;
          var filterPrarms_end_datetime = output.end_datetime;
          var filterPrarms_ticket_status = output.ticket_status;
          var filterPrarms_geo_region = output.geo_region;
          var filterPrarms_raised_by = output.raised_by;
          var filterPrarms = {
            crn: filterPrarms_crn,
            case_number: filterPrarms_case_number,
            caller_number: filterPrarms_caller_number,
            msisdn: filterPrarms_msisdn,
            start_datetime: filterPrarms_start_datetime,
            end_datetime: filterPrarms_end_datetime,
            ticket_status: filterPrarms_ticket_status,
            geo_region: filterPrarms_geo_region,
            raised_by: filterPrarms_raised_by
          };
          Curry._1(applyFilter, filterPrarms);
          return Curry._1(workspaceDispatch.replaceTab, {
                      TAG: /* Tickets */42,
                      _0: TicketsRequestMapper.DictEncoder.execute(filterPrarms)
                    });
        }));
  var isFormValid = function (request) {
    var match = request.start_datetime;
    var match$1 = request.end_datetime;
    var match$2 = PrimitiveFormTypes$Catalyst.getValue({
          TAG: /* String */1,
          _0: request.crn
        });
    var match$3 = PrimitiveFormTypes$Catalyst.getValue({
          TAG: /* String */1,
          _0: request.case_number
        });
    var match$4 = PrimitiveFormTypes$Catalyst.getValue({
          TAG: /* String */1,
          _0: request.caller_number
        });
    var match$5 = PrimitiveFormTypes$Catalyst.getValue({
          TAG: /* String */1,
          _0: request.msisdn
        });
    if (match !== undefined && match$1 !== undefined) {
      return {
              TAG: /* Ok */0,
              _0: "valid"
            };
    }
    if (match$2.TAG === /* Ok */0 || match$3.TAG === /* Ok */0 || match$4.TAG === /* Ok */0 || match$5.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: "valid"
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: "Select date range"
            };
    }
  };
  var getValdationErrComp = function (validationError) {
    if (validationError !== undefined) {
      return React.createElement("p", {
                  className: "error-server-msg"
                }, React.createElement("span", {
                      className: "error-msg"
                    }, validationError));
    } else {
      return null;
    }
  };
  React.useEffect((function () {
          Curry._1(form.reset, undefined);
          
        }), [filter]);
  React.useEffect((function () {
          Curry._1(updateError, (function (param) {
                  
                }));
          
        }), [
        form.input.end_datetime,
        form.input.start_datetime,
        form.input.crn,
        form.input.case_number,
        form.input.msisdn
      ]);
  var getSecondaryFiltersSection = function (param) {
    return React.createElement("div", {
                className: "accordian-content"
              }, React.createElement(FormSelectInput$Catalyst.make, {
                    input_props: FormInput$Catalyst.make_props("Geo Region", (function ($$event) {
                            return Curry._2(form.updateGeo_region, (function (input, value) {
                                          return {
                                                  crn: input.crn,
                                                  case_number: input.case_number,
                                                  caller_number: input.caller_number,
                                                  msisdn: input.msisdn,
                                                  start_datetime: input.start_datetime,
                                                  end_datetime: input.end_datetime,
                                                  ticket_status: input.ticket_status,
                                                  geo_region: value,
                                                  raised_by: input.raised_by
                                                };
                                        }), FormSelectInput$Catalyst.SelectUtils.getSelectedItemByValue(FormHelper$Catalyst.TargetEventWrapper.value($$event), geoRegionOptions));
                          }), undefined, undefined, undefined, undefined, undefined, undefined, form.geo_regionResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                    select_props: {
                      value: form.input.geo_region,
                      items: geoRegionOptions,
                      isNoneRequired: true
                    }
                  }), React.createElement(FormSelectInput$Catalyst.make, {
                    input_props: FormInput$Catalyst.make_props("Raised By", (function ($$event) {
                            return Curry._2(form.updateGeo_region, (function (input, value) {
                                          return {
                                                  crn: input.crn,
                                                  case_number: input.case_number,
                                                  caller_number: input.caller_number,
                                                  msisdn: input.msisdn,
                                                  start_datetime: input.start_datetime,
                                                  end_datetime: input.end_datetime,
                                                  ticket_status: input.ticket_status,
                                                  geo_region: input.geo_region,
                                                  raised_by: value
                                                };
                                        }), FormSelectInput$Catalyst.SelectUtils.getSelectedItemByValue(FormHelper$Catalyst.TargetEventWrapper.value($$event), raisedByOptions));
                          }), undefined, undefined, undefined, undefined, undefined, undefined, form.raised_byResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                    select_props: {
                      value: form.input.raised_by,
                      items: raisedByOptions,
                      isNoneRequired: true
                    }
                  }));
  };
  return React.createElement("div", {
              className: "filter-ticket-form"
            }, React.createElement(FormTextInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("CRN", (function ($$event) {
                          return Curry._2(form.updateCrn, (function (input, value) {
                                        return {
                                                crn: value,
                                                case_number: input.case_number,
                                                caller_number: input.caller_number,
                                                msisdn: input.msisdn,
                                                start_datetime: input.start_datetime,
                                                end_datetime: input.end_datetime,
                                                ticket_status: input.ticket_status,
                                                geo_region: input.geo_region,
                                                raised_by: input.raised_by
                                              };
                                      }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                        }), undefined, undefined, "Enter CRN", undefined, undefined, undefined, form.crnResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  textinput_props: {
                    value: form.input.crn
                  }
                }), React.createElement(FormTextInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("Case No.", (function ($$event) {
                          return Curry._2(form.updateCase_number, (function (input, value) {
                                        return {
                                                crn: input.crn,
                                                case_number: value,
                                                caller_number: input.caller_number,
                                                msisdn: input.msisdn,
                                                start_datetime: input.start_datetime,
                                                end_datetime: input.end_datetime,
                                                ticket_status: input.ticket_status,
                                                geo_region: input.geo_region,
                                                raised_by: input.raised_by
                                              };
                                      }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                        }), undefined, undefined, "Enter Case No.", undefined, undefined, undefined, form.case_numberResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  textinput_props: {
                    value: form.input.case_number
                  }
                }), React.createElement(FormTextInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("MSISDN", (function ($$event) {
                          return Curry._2(form.updateMsisdn, (function (input, value) {
                                        return {
                                                crn: input.crn,
                                                case_number: input.case_number,
                                                caller_number: input.caller_number,
                                                msisdn: value,
                                                start_datetime: input.start_datetime,
                                                end_datetime: input.end_datetime,
                                                ticket_status: input.ticket_status,
                                                geo_region: input.geo_region,
                                                raised_by: input.raised_by
                                              };
                                      }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                        }), undefined, undefined, "Enter MSISDN", undefined, undefined, undefined, form.msisdnResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  textinput_props: {
                    value: form.input.msisdn
                  }
                }), React.createElement(FormTextInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("Customer/Partner Mobile", (function ($$event) {
                          return Curry._2(form.updateCaller_number, (function (input, value) {
                                        return {
                                                crn: input.crn,
                                                case_number: input.case_number,
                                                caller_number: value,
                                                msisdn: input.msisdn,
                                                start_datetime: input.start_datetime,
                                                end_datetime: input.end_datetime,
                                                ticket_status: input.ticket_status,
                                                geo_region: input.geo_region,
                                                raised_by: input.raised_by
                                              };
                                      }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                        }), undefined, undefined, "Enter Customer/Partner Mobile", undefined, undefined, undefined, form.caller_numberResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  textinput_props: {
                    value: form.input.caller_number
                  }
                }), React.createElement(FormDateTimeInputTs$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("Start Date", (function (param) {
                          
                        }), undefined, undefined, undefined, undefined, undefined, undefined, form.start_datetimeResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  date_props: {
                    value: form.input.start_datetime,
                    minDate: undefined,
                    maxDate: form.input.end_datetime,
                    onChange: (function (date) {
                        return Curry._2(form.updateStart_datetime, (function (input, value) {
                                      return {
                                              crn: input.crn,
                                              case_number: input.case_number,
                                              caller_number: input.caller_number,
                                              msisdn: input.msisdn,
                                              start_datetime: value,
                                              end_datetime: input.end_datetime,
                                              ticket_status: input.ticket_status,
                                              geo_region: input.geo_region,
                                              raised_by: input.raised_by
                                            };
                                    }), Caml_option.some(date));
                      }),
                    format: "DD/MM/YYYY hh:mm A",
                    isDisabled: false,
                    onClear: (function (param) {
                        return Curry._2(form.updateStart_datetime, (function (input, value) {
                                      return {
                                              crn: input.crn,
                                              case_number: input.case_number,
                                              caller_number: input.caller_number,
                                              msisdn: input.msisdn,
                                              start_datetime: value,
                                              end_datetime: input.end_datetime,
                                              ticket_status: input.ticket_status,
                                              geo_region: input.geo_region,
                                              raised_by: input.raised_by
                                            };
                                    }), undefined);
                      })
                  }
                }), React.createElement(FormDateTimeInputTs$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("End Date", (function (param) {
                          
                        }), undefined, undefined, undefined, undefined, undefined, undefined, form.end_datetimeResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  date_props: {
                    value: form.input.end_datetime,
                    minDate: form.input.start_datetime,
                    maxDate: undefined,
                    onChange: (function (date) {
                        return Curry._2(form.updateEnd_datetime, (function (input, value) {
                                      return {
                                              crn: input.crn,
                                              case_number: input.case_number,
                                              caller_number: input.caller_number,
                                              msisdn: input.msisdn,
                                              start_datetime: input.start_datetime,
                                              end_datetime: value,
                                              ticket_status: input.ticket_status,
                                              geo_region: input.geo_region,
                                              raised_by: input.raised_by
                                            };
                                    }), Caml_option.some(date));
                      }),
                    format: "DD/MM/YYYY hh:mm A",
                    isDisabled: false,
                    onClear: (function (param) {
                        return Curry._2(form.updateEnd_datetime, (function (input, value) {
                                      return {
                                              crn: input.crn,
                                              case_number: input.case_number,
                                              caller_number: input.caller_number,
                                              msisdn: input.msisdn,
                                              start_datetime: input.start_datetime,
                                              end_datetime: value,
                                              ticket_status: input.ticket_status,
                                              geo_region: input.geo_region,
                                              raised_by: input.raised_by
                                            };
                                    }), undefined);
                      })
                  }
                }), React.createElement(FormSelectInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("Ticket Status", (function ($$event) {
                          return Curry._2(form.updateTicket_status, (function (input, value) {
                                        return {
                                                crn: input.crn,
                                                case_number: input.case_number,
                                                caller_number: input.caller_number,
                                                msisdn: input.msisdn,
                                                start_datetime: input.start_datetime,
                                                end_datetime: input.end_datetime,
                                                ticket_status: value,
                                                geo_region: input.geo_region,
                                                raised_by: input.raised_by
                                              };
                                      }), FormSelectInput$Catalyst.SelectUtils.getSelectedItemByValue(FormHelper$Catalyst.TargetEventWrapper.value($$event), ticketStatusOptions));
                        }), undefined, undefined, undefined, undefined, undefined, undefined, form.ticket_statusResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  select_props: {
                    value: form.input.ticket_status,
                    items: ticketStatusOptions,
                    isNoneRequired: true
                  }
                }), React.createElement(Accordion$Catalyst.make, {
                  panels: {
                    hd: AccordionTypes$Catalyst.make_props({
                          TAG: /* Custom */1,
                          _0: (function (param) {
                              return React.createElement("div", {
                                          className: "accordion-header"
                                        }, React.createElement("p", {
                                              className: "filter-field-section"
                                            }, "Additional Filters"), React.createElement("p", {
                                              className: "filter-field-section font-size-12 u-color-dark-grey"
                                            }, "Geo region, Raised by"));
                            })
                        }, undefined, undefined, getSecondaryFiltersSection(undefined), undefined),
                    tl: /* [] */0
                  },
                  className: "accordion-container filter-order-accordion-container",
                  defaultOpen: 1
                }), React.createElement("div", {
                  className: "apply-button-container"
                }, getValdationErrComp(match[0]), React.createElement("p", {
                      className: "results-found"
                    }, String(total_items) + " results found"), React.createElement("div", {
                      className: "same-row-button"
                    }, React.createElement(Button$Catalyst.make, {
                          text: "Apply",
                          cb: (function (_event) {
                              var _msg = isFormValid(form.input);
                              if (_msg.TAG === /* Ok */0) {
                                return Curry._1(form.submit, undefined);
                              }
                              var error = _msg._0;
                              return Curry._1(updateError, (function (param) {
                                            return error;
                                          }));
                            }),
                          className: "btn-primary apply-button"
                        }))));
}

var FormComponent = {
  make: FilterTicketForm$FormComponent
};

function FilterTicketForm(Props) {
  var filter = Props.filter;
  var applyFilter = Props.applyFilter;
  var total_items = Props.total_items;
  var match = CountryContext.useContext(undefined);
  GeoRegionRepoManager.getRepo(undefined);
  var geoRegions = GeoRegionHook.useGeoRegions(match.country);
  return React.createElement(FetchLoadableViewMapper$Catalyst.make, {
              loadableData: geoRegions,
              children: (function (geoRegions) {
                  if (geoRegions) {
                    return React.createElement(FilterTicketForm$FormComponent, {
                                geoRegions: geoRegions,
                                filter: filter,
                                applyFilter: applyFilter,
                                total_items: total_items
                              });
                  } else {
                    return React.createElement("div", undefined, "No Geo Regions found");
                  }
                })
            });
}

var make = FilterTicketForm;

export {
  FormHelper ,
  Form ,
  getInitialState ,
  FormComponent ,
  make ,
  
}
/* react Not a pure module */
